namespace GeniuzPOS.Customer {
    export interface CsCustGroupRow {
        Id?: number;
        CustGroupCode?: string;
        CustGroupName?: string;
        FullName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace CsCustGroupRow {
        export const idProperty = 'CustGroupCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Customer.CsCustGroup';
        export const lookupKey = 'Customer.CsCustGroup';

        export function getLookup(): Q.Lookup<CsCustGroupRow> {
            return Q.getLookup<CsCustGroupRow>('Customer.CsCustGroup');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ลูกค้า:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ลูกค้า:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ลูกค้า:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ลูกค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            CustGroupCode = "CustGroupCode",
            CustGroupName = "CustGroupName",
            FullName = "FullName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
